export const SUBSCRIPTION_TYPE_TRIAL = 0;
export const SUBSCRIPTION_TYPE_ITUNES = 1;
export const SUBSCRIPTION_TYPE_STRIPE = 2;
